export class Footer {
    constructor(data, storage) {
        Object.defineProperty(this, "tabs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tabs = data;
        this.storage = storage;
    }
    get hasLiveLessonNotification() {
        return this.tabs.liveSchedule.hasNotice && !this.storage.noticedLiveScheduleTabToday;
    }
}
